var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.498 33.0155C27.2138 33.0155 33.4687 26.7607 33.4687 19.0449C33.4687 11.3291 27.2138 5.07422 19.498 5.07422C11.7822 5.07422 5.52734 11.3291 5.52734 19.0449C5.52734 26.7607 11.7822 33.0155 19.498 33.0155Z",
    stroke: "#0D4740",
    strokeWidth: 3.10459
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1549 26.0296L19.498 19.0442V9.73047",
    stroke: "#0D4740",
    strokeWidth: 2.06973
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPending);
export default __webpack_public_path__ + "static/media/pending.557d8d08f0fa0b8ee4291db769b8a7e2.svg";
export { ForwardRef as ReactComponent };